<template>
  <div class="flex column" :class="media == 'file' && 'wrap'">
    <div v-if="!filelist" class="flex r4 align-center wrap">
      <button
        type="button"
        @click="media = media == 'file' ? false : 'file'"
        class="p4 update-border flex align-center"
        :style="media === 'file' && 'z-index: 9999999'"
      >
        <i class="fa fa-upload fa-sm update-text p4"></i>
      </button>
      <button
        v-if="!filelist"
        type="button"
        @click="media = media == 'filelist' ? false : 'filelist'"
        class=" p4 update-border flex align-center"
      >
        <i class="fa fa-folder fa-sm update-text p4"></i>
      </button>
      <!-- <button
        @click="media = media == 'sound' ? false : 'sound'"
        type="button"
        class="fit"
      >
        <i class="fa fa-microphone fa-sm"></i>
      </button>-->
    </div>

    <div class="flex wrap center" v-if="media === 'file'">
      <label
        class="xs-font flex column center white-bg p16 fill"
        for="file-upload"
        :style="`border: 2px dashed ${$store.state.app.style.update}; border-radius: 8px; box-shadow: inset 0 0 1px  ${$store.state.app.style.update}; z-index:99999; min-height: 120px; `"
      >
        <i class="fa fa-upload fa-3x p8 update-text"></i>
        <b class="flex center around p4">Tap or drag files here to upload</b>
        <input
          id="file-upload"
          multiple="true"
          v-if="media == 'file'"
          type="file"
          class="file-upload"
          style="position: absolute; opacity: 0; width: 100%; height: 100%; cursor: pointer;"
          @input="
            $store
              .dispatch('upload', {
                files: $event.target.files,
              })
              .then(() => {
                if (m && mtype) {
                  $store[mtype](m, {
                    files: $event.target.files,
                    name: name,
                  });
                }
                media = 'filelist';
              })
          "
        />
      </label>
    </div>
    <span v-if="files" class="xs-font flex wrap between align-center">
      <row w j="between" class="b4">
        <row>
          <i
            @click="$set(show, 'search', !show.search)"
            class="fa fa-search r4"
          ></i>
          <input
            v-if="show.search"
            type="text"
            placeholder="Search files"
            v-model="show.searchfiles"
          />
        </row>
        <select v-model="show.filtertype" name id>
          <option value>All Files</option>
          <option
            v-for="(type, ti) in [
              'application/',
              'audio/',
              'image/',
              'text/',
              'video/',
            ]"
            :value="type"
            :key="ti + type"
          >
            {{ type }}
          </option>
        </select>
      </row>
    </span>
    <div
      class="v-scroll flex column inshadow p4"
      :style="view == 'compact' && 'height: 100%; max-height: 320px; border-radius: 8px;'"
      v-if="
        (filelist || media == 'filelist') &&
        $store.state.user[$store.state.auth.uid] &&
        $store.state.user[$store.state.auth.uid].files &&
        Object.keys($store.state.user[$store.state.auth.uid].files).length > 0
      "
      :key="`userfiles-${
        Object.keys($store.state.user[$store.state.auth.uid].files).length
      }`"
    >
      <div
        v-for="file in files"
        :key="file.hash"
        @click="
          $set(show, file.hash, !show[file.hash]);
          select && attachments.includes((attachid && file.hash) || file.url[0])
            ? attachments.splice(
                attachments.indexOf((attachid && file.hash) || file.url[0]),
                1
              )
            : attachments.push((attachid && file.hash) || file.url[0]);
          updatevalue();
        "
      >
        <div
          class="flex b4 t4 p4 border-bottom"
          :class="
            select &&
            attachments.includes((attachid && file.hash) || file.url[0]) &&
            'success-border'
          "
          style="border-radius: 8px; margin-bottom: 8px; transition: all 0.2s ease;"
          v-if="
            JSON.stringify(file).includes(show.searchfiles) &&
            file.type.includes(show.filtertype)
          "
        >
          <div>
            <img
              class="icon"
              v-if="
                file.type && file.type.includes('image') && !show[file.hash]
              "
              :src="typeof file.url == 'string' ? file.url : file.url[0]"
              alt="file.name"
            />
            <i
              class="fa fa-file-check fa-3x success-text"
              v-else-if="
                select &&
                attachments.includes((attachid && file.hash) || file.url[0])
              "
            ></i>
            <i
              class="fa fa-file-audio fa-3x"
              v-else-if="file.type && file.type.includes('audio')"
            ></i>
            <i
              class="fa fa-file-video fa-3x"
              v-else-if="file.type && file.type.includes('video')"
            ></i>
            <i
              class="fa fa-file-pdf fa-3x"
              v-else-if="file.type && file.type.includes('pdf')"
            ></i>
            <i
              class="fa fa-file-code fa-3x"
              v-else-if="
                file.type &&
                [
                  'application',
                  'html',
                  'csv',
                  'json',
                  'model',
                  'font',
                ].includes(file.type.split('/')[0])
              "
            ></i>
            <i class="fa fa-file fa-3x" v-else></i>
          </div>
          <div class="flex column" :class="(view == 'compact' && 'p4') || 'p8'">
            <div class="flex between">
              <b style="overflow-wrap: anywhere" class="sm-font b8">
                <short :str="file.name" />
              </b>
              <div class="update-text p4 align-center between" v-if="file.token && !file.ipfs">
                <span
                  v-if="
                    !file.ipfs &&
                    file.ipfs !== 0 &&
                    !show.pinning[file.token[1]]
                  "
                  @click.stop="
                    $set(show.pinning, file.token[1], true);
                    $store.commit('point', {
                      header: `Pinning file to IPFS`,
                      text: `${file.name} is being watermarked and sent to IPFS. Please be patient...`,
                      sticky: false,
                      speed: 0,
                    });
                    $store.dispatch('blockfrostipfs', { file }).then((h) => {});
                  "
                >
                  <i class="fas fa-thumbtack fa-sm"></i> Pin to IPFS
                </span>
                <span class="warn-text container p4" v-if="file.ipfs === 0">
                  <i class="fa fa-exclamation-triangle"></i> IPFS already
                  pinned. You cannot tokenize this file. Contact support if this
                  is a database error.
                </span>
              </div>
              <rm
                v-if="!select"
                class="l8"
                :fn="{
                  command: 'dispatch',
                  method: 'delete',
                  type: 'files',
                  data: {
                    user: $store.state.auth.uid,
                    hash: file.hash,
                    name: file.name,
                  },
                }"
                :obj="$store.state.user[$store.state.auth.uid].files"
                :name="file.hash"
              />
            </div>
            <div v-if="view != 'compact'" class="flex align-center sm-font">
              <a
                style="
                  max-width: 240px;
                  overflow-x: scroll;
                  white-space: nowrap;
                "
                :href="typeof file.url == 'string' ? file.url : file.url[0]"
              >
                <code target="new" class="sm-font bold">
                  <short
                    :str="typeof file.url == 'string' ? file.url : file.url[0]"
                  />
                </code>
              </a>
              <div
                v-if="!select"
                class="flex align-center border-bottom around"
              >
                |
                <i
                  @click="
                    $copyText(
                      typeof file.url == 'string' ? file.url : file.url[0]
                    )
                  "
                  class="fa fa-copy l4"
                ></i>
                <!-- Tokenize from file hash, size, and type -->
              </div>
            </div>
            <img
              @click="!select && $set(show, file.hash, !show[file.hash])"
              style="width: 100%; object-fit: contain"
              v-if="
                show[file.hash] &&
                file.type &&
                file.type.includes('image') &&
                select &&
                attachments.includes((attachid && file.hash) || file.url[0])
              "
              :src="typeof file.url == 'string' ? file.url : file.url[0]"
              alt="file.name"
            />
            <audio
              controls
              v-if="show[file.hash] && file.type && file.type.includes('audio')"
              :src="typeof file.url == 'string' ? file.url : file.url[0]"
            >
              Your browser does not support audio elements. Tap the file link to
              download.
            </audio>
            <video
              style="width: 100%"
              controls
              v-if="show[file.hash] && file.type && file.type.includes('video')"
              :src="typeof file.url == 'string' ? file.url : file.url[0]"
            >
              Your browser does not support this video. Tap the file link to
              download.
            </video>
            <div v-if="!select">
              <span class="flex sm-font">
                <i class="r8">
                  Type:
                  <code>{{ file.type }}</code>
                </i>
                <i v-if="file.size">
                  Size:
                  <code>{{ file.size }}</code>
                </i>
              </span>
              <span class="flex align-center sm-font">
                File Hash:
                <code style="overflow-x: scroll" class="m4 border-bottom">
                  {{ file.hash }}
                </code>
                |
                <i @click="$copyText(file.hash)" class="fa fa-copy"></i>
              </span>
              <span v-if="file.token" class="flex align-center sm-font">
                Token Hash:
                <code
                  style="max-width: 240px; overflow-x: scroll"
                  class="m4 border-bottom"
                  >{{ file.token[1] }}</code
                >
                |
                <i @click="$copyText(file.token[1])" class="fa fa-copy"></i>
              </span>
              <span v-if="file.ipfs" class="flex align-center sm-font">
                <a target="new" :href="`https://ipfs.io/ipfs/${file.ipfs}`"
                  >IPFS Path</a
                >:
                <code
                  style="max-width: 240px; overflow-x: scroll"
                  class="m4 border-bottom"
                  >{{ file.ipfs }}</code
                >
                |
                <i @click="$copyText(file.ipfs)" class="fa fa-copy"></i>
                <div>
                  <a
                    @click="
                      $store.dispatch('util', {
                        type: 'decodewm',
                        id: file.ipfs,
                        url: `https://ipfs.io/ipfs/${file.ipfs}`,
                      })
                    "
                    >Decoded Image</a
                  >
                  <img
                    v-if="$store.state.decoded[file.ipfs]"
                    :src="$store.state.decoded[file.ipfs]"
                    alt=""
                  />
                </div>
              </span>
              <span v-if="file.ipfs" class="flex align-center sm-font">
                <a
                  target="new"
                  :href="`https://pool.pm/${file.cardanotokenpolicy}.${file.cardanotokenname}`"
                  >Cardano Token Policy</a
                >:
                <code
                  style="max-width: 240px; overflow-x: scroll"
                  class="m4 border-bottom"
                  >{{ file.cardanotokenpolicy }}</code
                >
                |
                <i
                  @click="$copyText(file.cardanotokenpolicy)"
                  class="fa fa-copy"
                ></i>
              </span>
              <span
                v-if="file.cardanotokentx"
                class="flex align-center sm-font"
              >
                <a
                  target="new"
                  :href="`https://cardanoscan.io/transaction/${file.cardanotokentx}`"
                  >Cardano Token Tx:</a
                >
                <code
                  style="max-width: 240px; overflow-x: scroll"
                  class="m4 border-bottom"
                  >{{ file.cardanotokentx }}</code
                >
                |
                <i
                  @click="$copyText(file.cardanotokentx)"
                  class="fa fa-copy"
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="container b8 m4 update-border"
      v-if="select && attachments.length > 0 && media == 'filelist'"
      style="border-radius: 8px;"
    >
      <h2 class="update p4">Selected Files</h2>
      <div v-for="file in attachments" :key="file" class="b4 p4" style="border-radius: 8px; margin-bottom: 8px;">
        <row w v-if="files" j="between" class="flex align-center"
          >
          <img class="b8" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;" :src="files.find(
              (x) => (attachid && x.hash == file) || x.url[0] == file
            ) &&
            files.find((x) => (attachid && x.hash == file) || x.url[0] == file).url[0]" alt=""/>
          <i class="success-text fa fa-file-check fa-lg r4"></i
          ><b class="flexw" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          {{
              files.find(
                (x) => (attachid && x.hash == file) || x.url[0] == file
              ) &&
              files.find((x) => (attachid && x.hash == file) || x.url[0] == file)
                .name
            }}
          </b>
          <rm :name="file" :obj="attachments"
        /></row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "media",
  props: {
    filelist: { type: Boolean },
    value: { type: [Array, String] },
    select: { type: Boolean },
    attachid: { type: Boolean },
    tokenfile: { type: Boolean },
    view: { type: String },
    m: { type: String },
    mtype: { type: String },
    name: { type: String },
  },
  computed: {
    cvalue() {
      return this.value;
    },
    files() {
      if (
        (this.$store.state.user[this.$store.state.auth.uid] && this.filelist) ||
        this.media == "filelist"
      ) {
        let files = this.$store.state.user[this.$store.state.auth.uid].files;
        return (
          files && Object.keys(files).length > 0 &&
          this.$_.orderBy(
            Object.entries(files).map((x) => {
              x[1].hash = x[0];
              return x[1];
            }),
            ["type", "name"]
          )
        );
      } else {
        return null;
      }
    },
  },
  data() {
    return {
      cloudurl: this.$store.state.cloudurl,
      media: false,
      contractcreated: "",
      confirmselleraddress: {},
      show: {
        addresses: false,
        selectmedia: {},
        search: false,
        searchfiles: "",
        filtertype: "",
        listtoken: {},
        minttoken: {},
        tokensent: {},
        pinning: {},
        decoded: {},
      },
      inputs: {
        chooseaddress: {},
      },
      signedtxs: {},
      contracts: {},
      tokendata: {},
      qrmintpayment: {},
      qrlistpayment: {},
      attachments: [],
      dev: this.$store.state.dev,
    };
  },
  methods: {
    async submitsignedtx(signed, file, type) {
      console.log({ signed, file, type });
      return this.$store
        .dispatch("api", {
          verb: "post",
          data: signed,
          address: this.cloudurl + `submitsignedtx?&dev=${this.dev}`,
        })
        .then((x) => {
          console.log({ x });
        })
        .catch((e) => e);
    },
    async createlistingcontracts(file, contracts) {
      this.$delete(file, "contracts");
      console.log("calling createlistingcontract endpoint", {
        file,
        contracts,
      });
      this.$store
        .dispatch("api", {
          address:
            this.cloudurl +
            `getassetinfo?client=agape&policyid=${file.cardanotokenpolicy}&hexname=${file.cardanotokenhex}`,
        })
        .then(async (x) => {
          console.log({ x });
          let contract = [
            {
              name: file.cardanotokenname,
              policy: file.cardanotokenpolicy,
              tx: file.cardanotokentx,
              fingerprint: file.cardanofingerprint,
              xmbl: file.token[1],
              holdingaddress: x.data.holdingaddress,
              amountid: file.tokenmintamountid.replace(".", ""),
              ask: contracts.amount,
              selleraddress: file.tokenpayeeaddress,
            },
          ];
          console.log({ x, contract: JSON.stringify(contract, null, 4) });
          return (
            this.$store
              .dispatch("api", {
                verb: "post",
                data: JSON.stringify(contract),
                // todo find why the entire data is loading as an object key on cloud
                address: this.cloudurl + `createlistingcontracts?client=agape`,
                //todo abstract client to app setting
              })
              //      store.commit('point', { header: 'Uploading file', text: 'Authenticating and checking tokenisation', sticky: true, time })

              .then((x) => {
                console.log(typeof x, { x });
                if (x.data && x.data.name && x.data.name === "Error")
                  return this.$store.commit("point", {
                    header: "Contract creation failed",
                    text: "No contracts have been deployed",
                    sticky: true,
                  });
                file.contracts = x.data;
                this.$store.dispatch("update", {
                  type: "files",
                  hash: file.hash,
                  data: file,
                });
              })
              .catch((e) => e)
          );
        });
    },
    async createcontract(file, contract) {
      this.$delete(file, "contracts");
      console.log({ file, contract });
      const amount = contract.amount || 1;
      const contractterms = {
        seller: file.assetsendaddress,
        amount,
        xmbltoken: file.token[1],
        nftname: file.cardanotokenname,
        nftpolicy: file.cardanotokenpolicy,
        nftnamehex: file.cardanotokenhex,
        nftfingerprint: file.cardanofingerprint,
      };
      return await this.$store
        .dispatch("util", { type: "hash", body: { contractterms } })
        .then((x) => {
          const contractid = x;
          // contractterms.file = file
          this.$set(this.show, "contractid", x);
          contractterms.hash = x;
          console.log({ contractid, contractterms, file });
          return this.$store
            .dispatch("api", {
              verb: "post",
              data: JSON.stringify(contractterms),
              address: this.cloudurl + `createtx?client=agape`, //todo abstract client to app setting
            })
            .then((x) => x)
            .catch((e) => e);
        });
    },
    updatevalue: function () {
      this.$emit("input", this.attachments);
    },
    updatefileurl(file, urls) {
      // todo get files from urls, check hash, update token
      console.log(file, urls);
    },
  },
  watch: {
    // refac

    // todo probably namespace these watchers or rethink strategy of catching uploaded url considering filereader isn't asyncing

    "$store.state.lastuploadurls": function () {
      if (
        !this.attachments.includes(
          this.$store.state.lastuploadurls[
            this.$store.state.lastuploadurls.length - 1
          ]
        ) ||
        !this.attachments.includes(
          this.$store.state.lastuploadhash[
            this.$store.state.lastuploadhash.length - 1
          ]
        )
      ) {
        if (this.tokenfile) {
          let fileid =
            this.$store.state.lastuploadhash[
              this.$store.state.lastuploadhash.length - 1
            ];
          this.$store
            .dispatch(
              "blockfrostipfs",
              {file: this.$store.state.user[this.$store.state.auth.uid].files[fileid]}
            )
            .then((h) => {
              console.log({ h });
              this.attachments.push(fileid);
              this.updatevalue();
            });
        } else {
          this.attachments.push(
            this.attachid
              ? this.$store.state.lastuploadhash[
                  this.$store.state.lastuploadhash.length - 1
                ]
              : this.$store.state.lastuploadurls[
                  this.$store.state.lastuploadurls.length - 1
                ]
          ),
            this.updatevalue();
        }
      }
    },
  },
};
</script>